<template>
  <div class="light-page">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="search-input-wrap">
        <svg class="search-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#999" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input 
          v-model="searchText" 
          type="text" 
          class="search-input" 
          placeholder="输入灯具型号或关键词搜索"
          @keyup.enter="handleSearch"
        />
        <div class="search-btn" @click="handleSearch">搜索</div>
      </div>
    </div>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div 
        class="filter-item" 
        v-for="(item, idx) in filterList" 
        :key="idx"
        :class="{ active: activeFilter === idx }"
        @click="handleFilter(idx)"
      >
        <span class="filter-text">{{ item.name }}</span>
        <svg class="filter-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
    </div>

    <!-- 灯具列表 -->
    <div class="light-list">
      <div 
        class="light-item" 
        v-for="(item, idx) in lightList" 
        :key="idx"
        @click="goDetail(item)"
      >
        <div class="light-image-wrap">
          <img :src="item.showImage" alt="" class="light-image" @error="handleImageError(item)" />
          <div v-if="!item.image" class="light-placeholder">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="#ddd">
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
            </svg>
          </div>
        </div>
        <div class="light-info">
          <div class="light-name">{{ item.materialCode }}</div>
          <div class="light-desc">{{ item.materialDesc }}</div>
          <div class="light-tags">
            <span 
              class="tag" 
              v-for="(tag, idx) in getTags(item)" 
              :key="idx"
            >{{ tag }}</span>
          </div>
        </div>
        <div class="light-action">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#10b981" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div v-if="hasMore" class="load-more" @click="loadMore">
      <span>加载更多</span>
      <svg v-if="loading" class="loading-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#10b981" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
      </svg>
    </div>

    <!-- 空状态 -->
    <div v-if="!loading && lightList.length === 0" class="empty-state">
      <svg viewBox="0 0 24 24" width="80" height="80" fill="#ddd">
        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
      </svg>
      <p class="empty-text">暂无灯具数据</p>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "AITest",
  data() {
    return {
      searchText: "",
      lightList: [],
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      activeFilter: 0,
      filterList: [
        { name: "类型", value: "" },
        { name: "风格", value: "" },
        { name: "功率", value: "" },
        { name: "颜色", value: "" },
        { name: "品牌", value: "" },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (this.loading) return;
      this.loading = true;
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          keyword:this.searchText
        };
        // if (this.searchText) {
        //   params.keyword = this.searchText;
        // }
        const res = await api.getLightInfo(params);
        console.log(res, "res咳咳咳咳咳咳");
        if (res.code === 200) {
          const list = res.data?.list || [];
          // 处理图片URL：保留原始image字段，新增showImage用于列表展示第一张图片
          list.forEach(item => {
            if (item.image && typeof item.image == 'string') {
              const imageIds = item.image.split(',').filter(id => id.trim());
              if (imageIds.length > 0) {
                item.showImage = `${api.imgUrl}${imageIds[0].trim()}`;
              } else {
                item.showImage = null;
              }
            }
          });
          console.log(list, "list");
          if (list.length < this.pageSize) {
            this.hasMore = false;
          }
          this.lightList = [...this.lightList, ...list];
        }
      } catch (error) {
        console.error("获取灯具数据失败:", error);
        this.$message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      if (!this.hasMore || this.loading) return;
      this.page++;
      this.loadData();
    },
    handleSearch() {
      this.page = 1;
      this.lightList = [];
      this.hasMore = true;
      this.loadData();
    },
    handleFilter(idx) {
      this.activeFilter = idx;
      this.page = 1;
      this.lightList = [];
      this.hasMore = true;
      this.loadData();
    },
    goDetail(item) {
      this.$router.push({
        path: "/qrCode/lightDetail",
        query: { 
          id: item.id,
          data: encodeURIComponent(JSON.stringify(item))
        },
      });
    },
    getTags(item) {
      const tags = [item.tag1, item.tag2, item.tag3, item.tag4, item.tag5];
      return tags.filter(Boolean);
    },
    handleImageError(item) {
      item.imageUrl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.light-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 30px;
}

.search-bar {
  padding: 20px 15px;
  background: #fff;
}

.search-input-wrap {
  display: flex;
  align-items: center;
  background: #f0f0f0;
  border-radius: 30px;
  padding: 12px 20px;
}

.search-icon {
  margin-right: 12px;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 28px;
  outline: none;
}

.search-btn {
  padding: 8px 20px;
  background: #10b981;
  color: #fff;
  border-radius: 20px;
  font-size: 24px;
  margin-left: 10px;
  cursor: pointer;
}

.filter-bar {
  display: flex;
  background: #fff;
  padding: 15px 10px;
  overflow-x: auto;
  white-space: nowrap;
  border-bottom: 1px solid #eee;
  
  &::-webkit-scrollbar {
    display: none;
  }
}

.filter-item {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-right: 15px;
  background: #f5f5f5;
  border-radius: 25px;
  font-size: 26px;
  color: #666;
  transition: all 0.3s ease;
  
  &.active {
    background: #10b981;
    color: #fff;
  }
  
  .filter-arrow {
    margin-left: 6px;
    transform: rotate(0deg);
    transition: transform 0.3s ease;
  }
  
  &.active .filter-arrow {
    transform: rotate(180deg);
  }
}

.light-list {
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
}

.light-item {
  width: calc(50% - 10px);
  margin-right: 10px;
  margin-bottom: 15px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  &:nth-child(2n) {
    margin-right: 0;
  }
}

.light-image-wrap {
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
}

.light-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.light-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.light-info {
  padding: 12px 15px;
}

.light-name {
  font-size: 26px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.light-desc {
  font-size: 22px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.light-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  font-size: 20px;
  padding: 4px 10px;
  background: #f0fdf4;
  color: #10b981;
  border-radius: 12px;
}

.light-action {
  padding: 10px 15px 15px;
  display: flex;
  justify-content: flex-end;
}

.load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  font-size: 26px;
  color: #666;
}

.loading-icon {
  animation: spin 1s linear infinite;
  margin-left: 10px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
}

.empty-text {
  margin-top: 20px;
  font-size: 26px;
  color: #999;
}

@media screen and (max-width: 600px) {
  .light-image-wrap {
    height: 180px;
  }
  
  .light-name {
    font-size: 24px;
  }
  
  .light-desc {
    font-size: 20px;
  }
  
  .tag {
    font-size: 18px;
    padding: 3px 8px;
  }
}
</style>
